import { SETTINGS_ROOT_PATH } from './constants';
import SettingsEdit from './SettingsEdit';

export default {
  path: SETTINGS_ROOT_PATH,
  component: SettingsEdit
}



// WEBPACK FOOTER //
// ./src/components/Settings/router.js